import { createMutationHook } from '~/shared/providers/api';

export const useDeleteTrailerMutation = createMutationHook(
  'transportation.trailerDelete',
  (params: { id: string }) => ({
    transportationTrailerDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
